<template>
    <v-container fill-height>
        <v-data-table
            :headers="headers"
            :items="ingredients"
            :items-per-page="5"
            class="elevation-5"
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Zutaten</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Neue Zutat</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.name" label="Zutatenname"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.protein" label="Eiweiß"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.calories" label="Kalorien"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.sugar" label="Zucker (g)"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.fat" label="Fett (g)"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.carbohydrates" label="Kohlenhydrate (g)"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.dietaryFiber" label="Ballaststoffe"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.alcohol" label="Alkohol (promille)"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.energyDensity" label="Energiedichte"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Abbrechen</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Speichern</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>

        </v-data-table>
    </v-container>
</template>

<script>

    export default {
        name: 'Zutaten',
      beforeMount () {
          this.$store.dispatch('fetchIngredients');
      },
      data: () => {
        return {
          search: '',
          dialog: false,
          headers: [
            {
                text: 'Name',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            {text: 'Eiweiß', value: 'protein'},
            {text: 'Fett', value: 'fat'},
            {text: 'Kohlenhydrate', value: 'carbohydrates'},
            {text: 'Zucker', value: 'sugar'},
            {text: 'Ballaststoffe', value: 'dietaryFiber'},
            {text: 'Alkohol', value: 'alcohol'},
            {text: 'Kalorien', value: 'calories'},
            {text: 'Energiedichte', value: 'energyDensity'},
            { text: 'Actions', value: 'actions', sortable: false },
          ],
          editedIndex: -1,
          editedItem: {
            name: '',
            protein: 0,
            fat: 0,
            carbohydrates: 0,
            sugar: 0,
            dietaryFiber: 0,
            alcohol: 0,
            calories:0,
            energyDensity:0
          },
          defaultItem: {
            name: '',
            protein: 0,
            fat: 0,
            carbohydrates: 0,
            sugar: 0,
            dietaryFiber: 0,
            alcohol: 0,
            calories:0,
            energyDensity:0
          }
        }
      },
      computed: {
        loading() { return this.$store.getters.isIngredientsLoading; },
        ingredients() { return this.$store.getters.getIngredients; },
        formTitle () {
            return this.editedIndex === -1 ? 'Neue Zutat' : 'Zutat editieren'
        },
      },
      watch: {
          dialog (val) {
              val || this.close()
          },
      },
      methods:{
        editItem (item) {
          this.editedIndex = this.posts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.dialog = true
        },

        deleteItem (item) {
          const index = this.ingredients.indexOf(item)
          if(confirm('Möchten SIe die Zutat wirklich löschen?')){
            this.$store.dispatch('deleteIngredient',index);
          }
        },
        close () {
          this.dialog = false
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300)
        },

        save () {
          if (this.editedIndex > -1) {
            // edit save to API
            let tranferObj = {
              inIndex: this.editedIndex,
              ingredient: this.editedItem
            }
            this.$store.dispatch('updateIngredient',tranferObj);
          } else {
              // save to API
            this.$store.dispatch('addIngredient',this.editedItem);
          }
          this.close()
        },
      }
    }
</script>

<style scoped>
    .container.fill-height{
        align-items: normal;

    }

    .v-data-table.elevation-5.theme--light{
        width: inherit;
    }
</style>